import { CircularProgress } from "@mui/material";
export default function PageLoaderComponent ()
{
    return (
        <div style={{ width: 1535,position: "fixed",
    background: "#d4d4d4",
    zIndex: 1,
    opacity: .8,
    height:800}}>
    <CircularProgress style={{position: "fixed",top:"50%",left:"50%", opacity: 1,}}/>
    </div>
    )
}